<template>
  <div>
    <ol class="am-breadcrumb">
      <li>
        <router-link :to="{path:'/edit'}" class="am-icon-home">控制台</router-link>
      </li>
      <li class="am-active">管理</li>
      <li class="am-active">分类</li>
    </ol>
    <div class="am-form">
      <div class="am-form-group">
        <span class="am-margin-right" v-for="type in typeList">
          <router-link :key="type.id" :to="{path:`/edit/type/${type.slug}`}">{{type.title}}</router-link>
        </span>
      </div>
      <div class="am-form-group">
        <label for="title">分类名</label>
        <input id="title" type="text" class="am-form-field am-radius" placeholder="请输入分类名..." v-model="title"/>
      </div>
      <div class="am-form-group">
        <label for="slug">分类缩略名</label>
        <input id="slug" type="text" class="am-form-field am-radius" placeholder="请输入分类缩略名..." v-model="slug"/>
      </div>
      <div class="am-form-group am-margin-top">
        <button class="am-btn am-btn-primary am-btn-xs" @click="save">保存</button>
      </div>
    </div>
    <ol class="am-breadcrumb">
      <li>
        <router-link :to="{path:'/edit'}" class="am-icon-home">控制台</router-link>
      </li>
      <li class="am-active">管理</li>
      <li class="am-active">分类</li>
    </ol>
  </div>
</template>

<script>
import { adminTypeGetList, adminTypeGet, adminTypeSave } from '@/request'
import {Toast} from "mint-ui"
export default {
  name: 'EditType',
  data () {
    return {
      id: null,
      slug: null,
      title: '',
      typeList: []
    }
  },
  mounted () {
    this.resetData()
  },
  watch: {
    $route: {
      handler: 'resetData'
    },
    title (val) {
      document.title = `${val}｜编辑`
    }
  },
  methods: {
    resetData () {
      const slug = this.$route.params.slug
      if(slug) {
        adminTypeGet({ slug }).then(res => {
          this.id = res.id
          this.slug = res.slug
          this.title = res.title
        })
      }
      adminTypeGetList().then(res => {
        this.typeList = res
      })
    },
    save () {
      adminTypeSave({
        id: this.id,
        slug: this.slug,
        title: this.title,
        content: this.content,
        allowComment: this.allowComment,
        status: this.status,
        password: this.password
      }).then(res => {
        this.id = res
        Toast("保存成功")
        this.$router.push({path:`/edit/type/${this.slug}`})
        this.resetData()
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/EditType.vue